import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Popover,
  Tooltip,
  Typography
} from '@mui/material';
import Flag from 'react-world-flags';

const languages = [
  { code: 'en', label: 'English', flag: 'GB' },
  { code: 'fr', label: 'Français', flag: 'FR' }
];

function HeaderLanguage() {
  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const { i18n } = useTranslation();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    handleClose();
  };

  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <>
      <Tooltip arrow title="Language">
        <IconButton color="primary" ref={ref} onClick={handleOpen}>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Flag code={currentLang.flag} style={{ width: 20, height: 14, borderRadius: 2 }} />
            <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '11px', lineHeight: 1 }}>
              {currentLang.code.toUpperCase()}
            </Typography>
          </Box>
        </IconButton>
      </Tooltip>

      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 150,
            maxWidth: 'calc(100vw - 16px)',
            backgroundColor: '#1a1d24',
            backgroundImage: 'none',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
            borderRadius: 2
          }
        }}
      >
        <Box sx={{ p: 1.5, borderBottom: '1px solid rgba(255, 255, 255, 0.05)' }}>
          <Typography variant="caption" sx={{ color: '#ffffff', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 }}>
            Language
          </Typography>
        </Box>
        <List sx={{ p: 0.5 }}>
          {languages.map((lang) => (
            <ListItemButton
              key={lang.code}
              selected={i18n.language === lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              sx={{
                borderRadius: 1,
                mb: 0.5,
                '&.Mui-selected': {
                  backgroundColor: 'rgba(24, 230, 142, 0.1)',
                  '&:hover': { backgroundColor: 'rgba(24, 230, 142, 0.15)' }
                },
                '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.05)' }
              }}
            >
              <Box display="flex" alignItems="center" gap={1.5}>
                <Flag code={lang.flag} style={{ width: 22, height: 16, borderRadius: 2 }} />
                <ListItemText
                  primary={lang.label}
                  primaryTypographyProps={{
                    fontSize: '14px',
                    fontWeight: i18n.language === lang.code ? 600 : 400,
                    color: i18n.language === lang.code ? '#18e68e' : 'rgba(255,255,255,0.8)'
                  }}
                />
              </Box>
            </ListItemButton>
          ))}
        </List>
      </Popover>
    </>
  );
}

export default HeaderLanguage;
